/****  React Tiny FAB - Deric Cain<deric.cain@gmail.com>  *****/
import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const AB=a=>React.createElement("button",_extends({type:"button"},a,{className:"rtf--ab"}),a.children);const MB=a=>React.createElement("button",_extends({type:"button",className:"rtf--mb"},a),a.children);class Fab extends React.Component{constructor(...a){super(...a),_defineProperty(this,"state",{open:!1}),_defineProperty(this,"enter",()=>"hover"===this.props.event&&this.open()),_defineProperty(this,"leave",()=>"hover"===this.props.event&&this.close()),_defineProperty(this,"open",()=>this.setState({open:!0})),_defineProperty(this,"close",()=>this.setState({open:!1})),_defineProperty(this,"toggle",()=>"click"===this.props.event?this.state.open?this.close():this.open():null),_defineProperty(this,"actionOnClick",a=>{this.setState({open:!1},()=>{
setTimeout(()=>{a();},1);});});}rc(){const{children:a,position:b}=this.props,{open:c}=this.state;return 6<React.Children.count(a)&&console.warn("react-tiny-fab only supports up to 6 action buttons"),React.Children.map(a,(a,d)=>React.createElement("li",{className:`rtf--ab__c ${"top"in b?"top":""}`},React.cloneElement(a,{"data-testid":`action-button-${d}`,"aria-label":a.props.text||`Menu button ${d+1}`,"aria-hidden":!c,...a.props,onClick:()=>this.actionOnClick(a.props.onClick)}),a.props.text&&React.createElement("span",{className:"right"in b?"right":"","aria-hidden":!c},a.props.text)))}render(){const{position:a,icon:b,mainButtonStyles:c}=this.props;return React.createElement("ul",{onMouseEnter:this.enter,onMouseLeave:this.leave,className:`rtf ${this.state.open?"open":"closed"}`,style:a},React.createElement("li",{className:"rtf--mb__c"},React.createElement(MB,{onClick:this.toggle,style:c,role:"button","aria-label":"Floating menu",tabIndex:"0"},b),React.createElement("ul",null,this.rc())))}}_defineProperty(Fab,"defaultProps",{position:{bottom:0,right:0},event:"hover"});

export { MB, Fab, AB as Action };
